import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="min-h-screen bg-bg-primary text-text-primary" dir="rtl">
      {/* Header */}
      <header className="bg-bg-secondary py-6">
        <div className="container mx-auto px-4 sm:px-6 md:px-8 lg:px-16">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-3">
              <img 
                src="/logos/10concept-logo.png"
                alt="10concept Logo"
                className="h-8 w-auto"
              />
              <span className="text-xl font-bold text-text-primary font-madani">10concept</span>
            </Link>
            <Link 
              to="/"
              className="text-text-secondary hover:text-primary transition-colors duration-300 font-madani"
            >
              العودة للرئيسية
            </Link>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="py-12 md:py-16">
        <div className="container mx-auto px-4 sm:px-6 md:px-8 lg:px-16 max-w-4xl">
          <h1 className="text-3xl md:text-4xl font-black text-text-primary mb-8 font-madani">
            سياسة الخصوصية
          </h1>
          
          <div className="prose prose-lg max-w-none text-text-secondary font-madani leading-relaxed">
            <p className="text-lg mb-6">
              نحن في شركة 10concept (دار إبداع) نحترم خصوصيتك ونلتزم بحماية معلوماتك الشخصية. 
              تشرح هذه السياسة كيفية جمعنا واستخدامنا وحمايتنا لمعلوماتك.
            </p>

            <h2 className="text-2xl font-bold text-text-primary mt-8 mb-4 font-madani">
              1. المعلومات التي نجمعها
            </h2>
            <ul className="list-disc list-inside space-y-2 mb-6">
              <li>المعلومات الشخصية التي تقدمها عند التواصل معنا</li>
              <li>معلومات الاتصال (الاسم، البريد الإلكتروني، رقم الهاتف)</li>
              <li>معلومات الاستخدام والتفضيلات</li>
              <li>معلومات تقنية (عنوان IP، نوع المتصفح، نظام التشغيل)</li>
            </ul>

            <h2 className="text-2xl font-bold text-text-primary mt-8 mb-4 font-madani">
              2. كيفية استخدام المعلومات
            </h2>
            <ul className="list-disc list-inside space-y-2 mb-6">
              <li>تقديم الخدمات المطلوبة</li>
              <li>تحسين تجربة المستخدم</li>
              <li>الرد على استفساراتك وطلباتك</li>
              <li>إرسال التحديثات والمعلومات المهمة</li>
              <li>تحليل استخدام الموقع لتحسين خدماتنا</li>
            </ul>

            <h2 className="text-2xl font-bold text-text-primary mt-8 mb-4 font-madani">
              3. مشاركة المعلومات
            </h2>
            <p className="mb-4">
              نحن لا نبيع أو نؤجر أو نشارك معلوماتك الشخصية مع أطراف ثالثة إلا في الحالات التالية:
            </p>
            <ul className="list-disc list-inside space-y-2 mb-6">
              <li>بموافقتك الصريحة</li>
              <li>للمزودين الخدمات الذين يعملون نيابة عنا</li>
              <li>عندما يتطلب القانون ذلك</li>
              <li>لحماية حقوقنا أو حقوق الآخرين</li>
            </ul>

            <h2 className="text-2xl font-bold text-text-primary mt-8 mb-4 font-madani">
              4. حماية المعلومات
            </h2>
            <p className="mb-4">
              نتخذ إجراءات أمنية مناسبة لحماية معلوماتك الشخصية من:
            </p>
            <ul className="list-disc list-inside space-y-2 mb-6">
              <li>الوصول غير المصرح به</li>
              <li>التعديل أو الحذف غير المصرح به</li>
              <li>الكشف غير المصرح به</li>
              <li>التدمير غير المصرح به</li>
            </ul>

            <h2 className="text-2xl font-bold text-text-primary mt-8 mb-4 font-madani">
              5. ملفات تعريف الارتباط (Cookies)
            </h2>
            <p className="mb-4">
              نستخدم ملفات تعريف الارتباط لتحسين تجربتك على موقعنا. يمكنك التحكم في ملفات 
              تعريف الارتباط من خلال إعدادات متصفحك.
            </p>

            <h2 className="text-2xl font-bold text-text-primary mt-8 mb-4 font-madani">
              6. حقوقك
            </h2>
            <p className="mb-4">لديك الحق في:</p>
            <ul className="list-disc list-inside space-y-2 mb-6">
              <li>الوصول إلى معلوماتك الشخصية</li>
              <li>تصحيح المعلومات غير الصحيحة</li>
              <li>حذف معلوماتك الشخصية</li>
              <li>الاعتراض على معالجة معلوماتك</li>
              <li>سحب الموافقة في أي وقت</li>
            </ul>

            <h2 className="text-2xl font-bold text-text-primary mt-8 mb-4 font-madani">
              7. التحديثات على السياسة
            </h2>
            <p className="mb-6">
              قد نقوم بتحديث هذه السياسة من وقت لآخر. سنقوم بإشعارك بأي تغييرات مهمة 
              من خلال موقعنا أو عبر البريد الإلكتروني.
            </p>

            <h2 className="text-2xl font-bold text-text-primary mt-8 mb-4 font-madani">
              8. التواصل معنا
            </h2>
            <p className="mb-6">
              إذا كان لديك أي أسئلة حول هذه السياسة أو تريد ممارسة أي من حقوقك، 
              يرجى التواصل معنا عبر:
            </p>
            <div className="bg-bg-secondary p-6 rounded-lg">
              <p className="mb-2"><strong>البريد الإلكتروني:</strong> info@10concept.sa</p>
              <p className="mb-2"><strong>الهاتف:</strong> +966580731010</p>
              <p><strong>العنوان:</strong> الرياض، المملكة العربية السعودية</p>
            </div>

            <div className="mt-8 pt-6 border-t border-gray-700">
              <p className="text-sm text-text-secondary">
                آخر تحديث: {new Date().toLocaleDateString('ar-SA')}
              </p>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-bg-secondary py-8 mt-16">
        <div className="container mx-auto px-4 sm:px-6 md:px-8 lg:px-16 text-center">
          <p className="text-text-secondary text-sm font-madani">
            © {new Date().getFullYear()} 10concept. جميع الحقوق محفوظة.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default PrivacyPolicy;
